module.exports = '4.10.1';



// WEBPACK FOOTER //
// ./src/version.js